import React from 'react';
import FileInput from 'components/shared/FileInput';
import { connect } from 'react-redux';
import { OPEN_CF } from 'constants/actionTypes';

class OpenCF extends React.Component {
  constructor(props) {
    super(props);
    this.handleCF = this.handleCF.bind(this);
  }

  handleCF(file) {
    // TODO: this should be handled async way https://redux.js.org/advanced/async-actions
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = (e) => {
      const cfArrayBuffer = e.target.result;
      let utf8decoder = new TextDecoder();
      let cfString = utf8decoder.decode(cfArrayBuffer);
      this.props.openCF(cfString);
    };
  }

  render() {
    return (
      <FileInput
        id={this.props.id}
        handleFile={this.handleCF}
        label={this.props.label}
        accept=".cf"
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  openCF: (cf) => dispatch({ type: OPEN_CF, cf }),
});

export default connect(null, mapDispatchToProps)(OpenCF);
